var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"grid-x grid-padding-x"},[_c('div',{staticClass:"cell auto"},[_c('slim-cropper',{attrs:{"options":_vm.slimOptions}},[_c('input',{attrs:{"type":"file"}})]),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":_vm.fieldname},domProps:{"value":_vm.uploadedFile}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /~/vue-loader/lib/template-compiler?{"id":"data-v-90ad3c2a","hasScoped":false,"buble":{"transforms":{}}}!/~/vue-loader/lib/selector.js?type=template&index=0!./assets/js/vue/components/SlimUploader.vue
// module id = 419
// module chunks = 0